module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pam Lintott, Nicky Lintott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Pam Lintott is the co-author of "), _c('I', [_vm._v("Jelly Roll Quilts")]), _vm._v(" and the owner of The Quilt Room, Europe's premiere quilting and patchwork shop. Together with her daughter Nicky, Pam has also written "), _c('I', [_vm._v("Layer Cake, Jelly Roll and Charm Quilts")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vnr5cq/tc-custom/9781446350935.jpg?1737060338355",
      "alt": "This image is the cover for the book Jelly Roll Inspirations"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jelly Roll Inspirations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Grab a jelly roll bundle and prepare to make a beautiful quilt with one of the twelve designs in this collection compiled by the authors of "), _c('i', [_vm._v("Jelly Roll Quilts")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" The Jelly Roll Challenge was an international competition to find the best and most creative use of one Jelly Roll. Gathered here are the twelve fabulous winning entries with step-by-step instructions on how to make them."), _c('br'), _c('br'), _vm._v(" · A dozen Jelly Roll quilt designs"), _c('br'), _vm._v(" · Get inspired by these designers and their unique take on the Jelly Roll"), _c('br'), _vm._v(" · Each quilt has a variation made by bestselling authors Pam and Nicky Lintott")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David and Charles\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0